<template>
  <div class="page-content congrats">
    <div class="congrats__container">
      <img class="bg-image" src="@/assets/images/congrat-bg.jpg" alt="image description" aria-hidden="true">
      <div class="congrats__heading">
        <h1>get real. california quiz. </h1>
        <h2>Congratulations! </h2>
          <p>Tally your points to determine the winner.
            <br>Play again to try to beat your score.
            <br>Or challenge your family and friends!</p>
      </div>
      <div class="congrats__content">
        <div class="congrats__text">
            <a href="#" class="btn-next" @click="restartApp">
              <span>play again </span>
            </a>
          </div>
        </div>
      </div>
      <div class="logo-row-bottom">
      <div class="logo-holder">
        <img src="@/assets/images/ymi.png" width="53" height="43" alt="image description">
      </div>
      <div class="logo-holder">
        <img src="@/assets/images/got-milk.png" width="191" height="55" alt="image description">
        <p class="copy">&copy; 2024 California Milk Processor Board</p>
      </div>
    </div>
    </div>
  <ConfettiExplosion
      v-if="isVisible"
      class="confetti-overlay"
      :duration="10000"
      :stageHeight="screenHeight"
      :stageWidth="screenWidth"
      :shouldDestroyAfterDone="true"
      :particleCount="250"
      :colors="confettiOptions.colors" />
</template>

<script>
  import { mapMutations } from "vuex"
  import ConfettiExplosion from "vue-confetti-explosion"

  export default {
    name: "Congrats",
    components: {
      ConfettiExplosion
    },
    data() {
      return {
        confettiOptions: {
          colors: ['var(--yellow)', 'var(--red)', 'var(--blue)', 'var(--gray)', 'var(--blue-light)']
        },
        isVisible: false,
        screenHeight: 0,
        screenWidth: 0
      }
    },
    methods: {
    ...mapMutations({
        restartApp() {
          window.location.reload();
        },
        play: 'play'
      }),
      goToNextStep() {
        this.next();
      }
    },
    mounted() {
      this.play('congrats')
      this.isVisible = true
      this.screenHeight = window.innerHeight * 2
      this.screenWidth = window.innerWidth * 2
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>
